import React from 'react';
import update from 'immutability-helper';
import Item from './Item';
import FormLabel from '@/components/input/FormLabel';
import Button from '@/components/input/Button';
import { Add } from '@mui/icons-material';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import theme from '@/constants/theme';
import { OverView } from '..';

interface Props {
  benefits: OverView['benefits'];
  setOverview: React.Dispatch<React.SetStateAction<OverView>>;
}

const Benefits: React.FC<Props> = ({ benefits, setOverview }) => {
  const handleChangeOptions = (optionIndex: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setOverview((prevQuiz) =>
      update(prevQuiz, {
        benefits: {
          [optionIndex]: { $set: e.target.value },
        },
      }),
    );
  };

  const removeOption = (optIndex: number) => {
    setOverview((prevQuiz) =>
      update(prevQuiz, {
        benefits: {
          $splice: [[optIndex, 1]],
        },
      }),
    );
  };

  const addOption = () => {
    setOverview((prevQuiz) =>
      update(prevQuiz, {
        benefits: {
          $push: [''],
        },
      }),
    );
  };

  const moveOption = (fromIndex: number, toIndex: number) => {
    setOverview((prevOverview) => {
      if (!prevOverview) return prevOverview;
      const value = prevOverview.benefits[fromIndex];
      return update(prevOverview, {
        benefits: {
          $splice: [
            [fromIndex, 1],
            [toIndex, 0, value],
          ],
        },
      });
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <FormLabel
        label="Beneficios"
        helperText="Este contenido se mostrará antes de comenzar un contenido y al completar uno."
      />
      {benefits.length === 0 && (
        <span style={{ color: theme.colors.text.caption }}>No hay beneficios definidos</span>
      )}

      <DndProvider backend={HTML5Backend}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {benefits.map((option, optIndex) => (
            <Item
              key={optIndex}
              option={option}
              optIndex={optIndex}
              index={optIndex}
              moveOption={moveOption}
              handleChangeOptions={handleChangeOptions}
              removeOption={removeOption}
            />
          ))}
        </div>
      </DndProvider>
      <Button
        size="small"
        type="button"
        variant="outline"
        sx={{ alignSelf: 'start' }}
        Icon={Add}
        onClick={addOption}
      >
        Añadir Beneficio
      </Button>
    </div>
  );
};

export default Benefits;
